import styled from 'styled-components'

export const Style = styled.div`
  .image-map {
    justify-content: center;
    display: flex;
  }
  .container-map {
    position: relative;
  }

  .north,
  .east,
  .west,
  .center,
  .south {
    z-index: 1;
    position: absolute;
    transition: all 0.7s ease-in;

    > img {
      path {
        fill: #000;
      }
      &:first-child {
        opacity: 1;
        visibility: visible;
        display: block;
      }
      &:last-child {
        opacity: 0;
        visibility: hidden;
        display: none;
      }
    }
  }
  .north {
    top: 0;
    width: 486px;
    right: 0;
  }
  .east {
    top: 110px;
    width: 252px;
    right: 1px;
  }
  .west {
    top: 7px;
    width: 267px;
    left: 5px;
  }
  .center {
    top: 82px;
    width: 170px;
    left: 201px;
  }
  .south {
    bottom: 3px;
    width: 261px;
    left: 91px;
  }

  .text-north {
    right: 80px;
    top: 60px;
  }

  .text-east {
    right: 80px;
    top: 205px;
  }

  .text-west {
    left: 80px;
    top: 125px;
  }

  .text-center {
    left: 250px;
    top: 135px;
  }

  .text-south {
    position: absolute;
    left: 187px;
    z-index: 2;
    cursor: pointer;
    bottom: 160px;
  }

  img {
    transition: all 0.7s ease-in;
    width: 100%;
    display: block;
  }
  span {
    font-family: 'Open Sans', sans-serif;
    font-size: 18px;
    font-weight: bold;
    display: block;
    color: #6e8482;
    text-align: center;
    transition: all 0.3s ease-in-out;
  }
  .text-map {
    position: absolute;
    z-index: 2;
    cursor: pointer;
    &:hover {
      > span {
        color: #fff;
        font-size: 22px;
        transition: all 0.3s ease-in-out;
      }
      + div {
        > img {
          &:first-child {
            opacity: 1;
            visibility: hidden;
            display: none;
          }
          &:last-child {
            opacity: 1;
            visibility: visible;
            display: block;
          }
        }
      }
    }
  }
  @media screen and (min-width: 300px) and (max-width: 600px) {
    display: none;
  }
  .grid-margin {
    margin-top: 60px;
  }
  .column-bottom {
    margin-bottom: 60px;
  }
  .top-margin {
    margin-top: 20px;
  }
  .display-content {
    display: flex;
    justify-content: center;
  }
`
